import React, { createContext, useContext, useState, type ReactNode, type JSX } from 'react';

interface ChatDockContextType {
  isDocked: boolean;
  setIsDocked: (isDocked: boolean) => void;
  drawerWidth: number;
  setDrawerWidth: (width: number) => void;
}

const ChatDockContext = createContext<ChatDockContextType | undefined>(undefined);

const MIN_DRAWER_WIDTH = 375;
const DEFAULT_DRAWER_WIDTH = 500;

type ChatDockProviderProps = {
  children: ReactNode;
};

export const ChatDockProvider = ({ children }: ChatDockProviderProps): JSX.Element => {
  const [isDocked, setIsDocked] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(DEFAULT_DRAWER_WIDTH);

  return (
    <ChatDockContext.Provider value={{ isDocked, setIsDocked, drawerWidth, setDrawerWidth }}>
      {children}
    </ChatDockContext.Provider>
  );
};

export { MIN_DRAWER_WIDTH, DEFAULT_DRAWER_WIDTH };

export const useChatDock = (): ChatDockContextType => {
  const context = useContext(ChatDockContext);
  if (!context) {
    throw new Error('useChatDock must be used within a ChatDockProvider');
  }
  return context;
};
